import { useRef, useEffect } from 'react';

// runs an effect starting from the first render (mounting)
export const useDelayedEffect = (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) return func();
    didMount.current = true;
  }, deps);
};
